import { render, staticRenderFns } from "./CustomerType.vue?vue&type=template&id=0ea542f8&"
import script from "./CustomerType.vue?vue&type=script&lang=js&"
export * from "./CustomerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports